import React from 'react'

export default function FeaturedContentItem(
  {
    cta,
    cta_gtm_id,
    featured_title,
    featured_content,
    cta_analtytics,
    featured_image,
    index
  }
){
  featured_content = { __html: featured_content }
  return (
    <section className="featured-content">
      <div className="container--main">
        <div className="featured-content__item">
          <div className="featured-content__wrapper--with-image ">
            <div className="featured-content__text">
              <h3 className="heading heading--lg">{featured_title}</h3>
              <div className="u-mt4" dangerouslySetInnerHTML={ featured_content } />
            </div>
            { cta &&
              <a
                href={ cta.url } id={ cta_gtm_id } target={ cta.target } className="button button--lg button--arrow"
                onClick = { ()=>{ cta_analtytics && console.log( cta_analtytics[0]) } }
              >
                { cta.title }
              </a>
            }
          </div>
          <div className="featured-content__icon">
            { featured_image && <img src={featured_image.url} alt={ featured_image.alt } /> }
          </div>
        </div>
      </div>
    </section>
  )
}
